import { useGetParticipantsQuery } from "../participantsSlice";
import useOrganisationId from "../../organisations/hooks/useOrganisationId";
import useHasAccess from "../../../hooks/useHasAccess";
import useRefresher from "../../../hooks/useRefresher";

const useParticipants = () => {
  const organisationId = useOrganisationId();
  const hasAccess = useHasAccess({
    apiCall: "organisations.id.participants.GET",
    organisation: organisationId,
  });

  const participants = useGetParticipantsQuery(
    { id: organisationId },
    { skip: organisationId == null || !hasAccess }
  );
  useRefresher(participants);

  return { ...participants, hasAccess };
};

export default useParticipants;
